import type {
  Comment,
  CommentListResponse,
  CreateCommentRequest,
  UpdateCommentRequest,
} from '@lens/shared';
import { apiRequest } from '../../shared/api/client.ts';

export async function listItemComments(
  spaceId: string,
  itemId: string,
): Promise<CommentListResponse> {
  return apiRequest<CommentListResponse>(
    `/api/spaces/${spaceId}/items/${itemId}/comments`,
    { method: 'GET' },
  );
}

export async function createItemComment(
  spaceId: string,
  itemId: string,
  data: CreateCommentRequest,
): Promise<Comment> {
  return apiRequest<Comment>(
    `/api/spaces/${spaceId}/items/${itemId}/comments`,
    { method: 'POST', body: data },
  );
}

export async function updateComment(
  spaceId: string,
  commentId: string,
  data: UpdateCommentRequest,
): Promise<Comment> {
  return apiRequest<Comment>(
    `/api/spaces/${spaceId}/comments/${commentId}`,
    { method: 'PATCH', body: data },
  );
}

export async function deleteComment(
  spaceId: string,
  commentId: string,
): Promise<void> {
  await apiRequest<void>(
    `/api/spaces/${spaceId}/comments/${commentId}`,
    { method: 'DELETE' },
  );
}
